export default __webpack_public_path__ + "efda3f8bd4a92d61f9f8697fd5526edb.svg";